import React from 'react'
import { Tabs, Tab, Button } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import Headroom from 'react-headroom'
import { INavTabProps } from '../../interface'
import { TabsBox } from '../../styles'
import { FormattedMessage } from 'react-intl'

interface INavBarSecondary {
  navBarSecondaryTab?: any
  indicatorColor?: string
  storeURL?: string
}

export default function NavBarSecondary(props: INavBarSecondary) {
  const location = useLocation()
  const [value, setValue] = React.useState(false)

  React.useEffect(() => {
    const val = props.navBarSecondaryTab.findLastIndex((item: INavTabProps) =>
      window.location.pathname.startsWith(item.url)
    )
    setValue(val > -1 ? val : false)
  }, [location, props.navBarSecondaryTab])

  return (
    <Headroom style={{ top: 'auto', zIndex: 99, height: 72 }}>
      <TabsBox sx={{ alignItems: 'center', height: '100%' }}>
        <Tabs
          value={value}
          TabIndicatorProps={{
            style: {
              backgroundColor: props.indicatorColor
            }
          }}
        >
          {props.navBarSecondaryTab.map((navTab: INavTabProps) => (
            <Tab
              data-gtm-click-secondary-navbar={navTab.gtmData}
              sx={{ height: '100%', minHeight: 72 }}
              disableRipple={true}
              component={Link}
              label={navTab.label}
              to={navTab.url}
              key={navTab.url}
              data-cy={navTab.dataCy}
            />
          ))}
        </Tabs>
        {props.storeURL && (
          <Button
            data-gtm-click-secondary-navbar='Buy_Now'
            size='small'
            variant='contained'
            color='secondary'
            sx={{ fontSize: '.75rem', fontWeight: 700, mx: 2 }}
            component={Link}
            to={props.storeURL}
          >
            <FormattedMessage id='common.buyNow' />
          </Button>
        )}
      </TabsBox>
    </Headroom>
  )
}
